import { DocumentsReportCategoryDTO } from "../../../models/documents/documents-reports";

export const TABLE_CELL = "table-cell";
export const PERIOD_CELL_ROW = "period-cells-row";
export const TABLE_BODY_ROW = "table-body-row";

export const getPeriodIds = (items: DocumentsReportCategoryDTO[], period: string): string[] => {
  const ids: string[] = [];
  items.forEach((item) => {
    item.reportCategoryGroups?.forEach((reportCategoryGroup) => {
      const docsByPeriod = reportCategoryGroup.docsByPeriod?.filter((docByPeriod) => docByPeriod.period === period);

      docsByPeriod?.forEach((docByPeriod) => {
        docByPeriod.documents?.forEach((doc) => {
          ids.push(doc.id);
        });
      });
    });
  });

  return ids;
};

export const hasPeriodIds = (items: DocumentsReportCategoryDTO[], period: string): boolean =>
  getPeriodIds(items, period).length > 0;
